/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Adr_Font_SizeInputs */



/**
* | output |
* | --- |
* | "ADR Font Size" |
*
* @param {Options_Adr_Font_SizeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_adr_font_size = /** @type {((inputs?: Options_Adr_Font_SizeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Adr_Font_SizeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Taille de police ADR")
	if (locale === "de") return /** @type {LocalizedString} */ ("ADR-Schriftgröße")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dimensione carattere ADR")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Размер шрифта ADR")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tamaño de fuente ADR")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("ADR字体大小")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ADRフォントサイズ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एडीआर फ़ॉन्ट आकार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tamanho da fonte ADR")
	return /** @type {LocalizedString} */ ("ADR Font Size")
});